<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 GRUPOS DECORATIVOS (FLOR + RAMA) -->
    <div class="deco-group deco-lt">
      <img src="@/assets/fl.png" class="flor" />
      <img src="@/assets/rama.png" class="rama" />
    </div>
    <div class="deco-group deco-lb">
      <img src="@/assets/fl.png" class="flor" />
      <img src="@/assets/rama.png" class="rama" />
    </div>
    <div class="deco-group deco-rt">
      <img src="@/assets/fl.png" class="flor" />
      <img src="@/assets/rama.png" class="rama" />
    </div>
    <div class="deco-group deco-rb">
      <img src="@/assets/fl.png" class="flor" />
      <img src="@/assets/rama.png" class="rama" />
    </div>

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img :src="image" class="collage-image" :alt="'Imagen ' + index" />
      </div>
    </div>

    <!-- MODAL -->
    <div v-if="isImageEnlarged" class="image-modal" @click="closeModal">
      <img :src="images[currentIndex]" class="enlarged-image" />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [require('@/assets/IMG_4450_1.webp')]
    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])
    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => (isImageEnlarged.value = false)

    onMounted(async () => {
      await nextTick()
      collageItems.value = collageItems.value.slice(0, images.length)

      const flores = rootRef.value.querySelectorAll('.flor')
      const ramas = rootRef.value.querySelectorAll('.rama')
      const grupos = rootRef.value.querySelectorAll('.deco-group')

      /* ESTADOS INICIALES */
      gsap.set(bgRef.value, { opacity: 0 })
      gsap.set(flores, { opacity: 0, scale: 0.8, y: 10 })
      // La rama inicia pequeña y oculta detrás de la flor
      gsap.set(ramas, { opacity: 0, scale: 0.2, y: 0, transformOrigin: "center center" })
      gsap.set(collageItems.value, { opacity: 0 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          /* 1️⃣ FONDO */
          tl.to(bgRef.value, { opacity: 1, duration: 0.6 })

          /* 2️⃣ FLORES */
          tl.to(flores, {
            opacity: 0.85,
            scale: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1
          }, "-=0.2")

          /* 3️⃣ RAMAS (Nacen desde el centro de la flor hacia afuera) */
          tl.to(ramas, {
            opacity: 0.7,
            scale: 1.5, // Crecen más que la flor para que se vean
            y: 40,      // Se desplazan un poco hacia abajo
            duration: 1.8,
            stagger: 0.2,
            ease: "power1.out"
          }, "-=0.4")

          /* MOVIMIENTO FLOTANTE */
          grupos.forEach((grupo, i) => {
            gsap.to(grupo, {
              y: "+=15",
              duration: 3 + i,
              repeat: -1,
              yoyo: true,
              ease: "sine.inOut"
            })
          })

          /* 4️⃣ FOTOS */
          tl.to(collageItems.value, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2
          }, "-=1.2")

          io.disconnect()
        })
      }, { threshold: 0.3 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { images, rootRef, bgRef, collageItems, currentIndex, isImageEnlarged, enlargeImage, closeModal }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: visible;
}

.bg-rosa {
  position: absolute;
  inset: 0;
  overflow: visibñe;
  background: #d6cabd;
  z-index: 0;
}

/* 🌸 GRUPOS DECORATIVOS */
.deco-group {
  position: absolute;
  z-index: 999;
  width: 80px; /* Tamaño base */
  height: 100px;
  margin-right: 3px;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flor {
  width: 130px;
  height: auto;
  position: relative;
  z-index: 2; /* Flor al frente */
}

.rama {
  position: absolute; /* Clave: para que no empuje a la flor */
  width: 170px;      /* Más grande que la flor */
  height: auto;
  z-index: 10;   
  margin-top:0px;      /* Rama atrás */
  filter: brightness(1.1) opacity(0.8);
  top: 10%;           /* Ajuste fino de posición */
}

/* POSICIONES ORILLAS */
.deco-lt { top: -3vh; left: -20px; }
.deco-lb { bottom: 5vh; left: -30px; }
.deco-rt { top: -3vh; right: -20px; }
.deco-rb { bottom: 5vh; right: -30px; }

.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 8vh 0;
}

.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  margin-bottom: 5vh;
}

.collage-image {
  width: 90%;
  margin: 0 auto;
  display: block;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 8px;
}

.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: visible !important;
  height: 60px;
  z-index: 10;
  background: #d6cabd;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
  transform: rotate(180deg);
  z-index: 10;
}
</style>